import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ProductData } from "../types";

export interface ProductResponse extends ApiResponse {
    data: ProductData[];
}

export const fetchProducts = () => {
    return apiClient<ProductResponse>("/v1/catalogs/products", {
        method: "GET"
    }).then(res => res.data);
}
